import { render, staticRenderFns } from "./CBreadCrumbs.vue?vue&type=template&id=5617cf9d&scoped=true&"
import script from "./CBreadCrumbs.vue?vue&type=script&lang=ts&"
export * from "./CBreadCrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./CBreadCrumbs.vue?vue&type=style&index=0&id=5617cf9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5617cf9d",
  null
  
)

export default component.exports